module.exports = __webpack_public_path__ + "static/img/alliance-logo13.a4228dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_b2c/alliance-logo13.png
// module id = tf9t
// module chunks = 0